import Mutations from '../../odata/mutations';

export default { ...new Mutations('checklistItemTransaction'), ...new Mutations('checklistItemTransactions') };
